module.exports = __webpack_public_path__ + "img/page2-bg.b79d7b2f.png";